/// <reference path="../../vendor/angular/angular.js" />
'use strict';

angular.module('userRequestArrivalControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment',
    'directives.IAMContact',
    'services.search'
]);